import React, { useEffect, useState } from "react";
import { getCustomers, deleteCustomer } from "../api/api";
import "../styles/Customers.css";

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [error, setError] = useState("");
  const [stats, setStats] = useState({
    total: 0,
    today: 0,
    week: 0,
  });

  useEffect(() => {
    fetchCustomers();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCustomers = async () => {
    try {
      const res = await getCustomers();
      if (Array.isArray(res.data)) {
        // Sort by created_at descending so newest come first
        const sorted = [...res.data].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setCustomers(sorted);
        computeStats(sorted);
      } else {
        throw new Error("Unexpected data format");
      }
    } catch (err) {
      console.error(err);
      setError("Failed to load customers");
    }
  };

  const computeStats = (list) => {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startOfWeek = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);

    let today = 0,
      week = 0;
    list.forEach((c) => {
      const joined = new Date(c.created_at);
      if (joined >= startOfToday) today++;
      if (joined >= startOfWeek) week++;
    });
    setStats({ total: list.length, today, week });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this customer?")) return;
    try {
      await deleteCustomer({ id });
      fetchCustomers();
    } catch (err) {
      console.error(err);
      alert("Failed to delete customer");
    }
  };

  return (
    <div className="customers">
      <h2>Manage Customers</h2>
      {error && <p className="error">{error}</p>}

      <div className="stats">
        <div className="stat-card blue">
          <h3>{stats.total}</h3>
          <p>Total Customers</p>
        </div>
        <div className="stat-card green">
          <h3>{stats.today}</h3>
          <p>New Today</p>
        </div>
        <div className="stat-card blue">
          <h3>{stats.week}</h3>
          <p>New This Week</p>
        </div>
      </div>

      <div className="table-container">
        <table className="customers-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Address</th>
              <th>Joined Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {customers.length > 0 ? (
              customers.map((c) => (
                <tr key={c.id}>
                  <td>{c.name}</td>
                  <td>{c.email}</td>
                  <td>{c.phone || "—"}</td>
                  <td>{c.address || "—"}</td>
                  <td>{new Date(c.created_at).toLocaleDateString()}</td>
                  <td>
                    <button
                      className="view-btn"
                      onClick={() => alert(JSON.stringify(c, null, 2))}
                    >
                      👁
                    </button>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(c.id)}
                    >
                      🗑
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center" }}>
                  No customers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Customers;